export default __webpack_public_path__ + "static/media/webopen.03e25a78.png";